export const ACTIVATE_SCANNER = 'cboard/ScannerProvider/ACTIVATE_SCANNER' as const;
export const DEACTIVATE_SCANNER = 'cboard/ScannerProvider/DEACTIVATE_SCANNER' as const;
export const TOGGLE_SCANNER = 'cboard/ScannerProvider/TOGGLE_SCANNER' as const;
export const UPDATE_SCANNER_SETTINGS = 'cboard/ScannerProvider/UPDATE_SCANNER_SETTINGS' as const;
